import { render, staticRenderFns } from "./ProductStockMovementBox.vue?vue&type=template&id=65c6abd7&scoped=true"
import script from "./ProductStockMovementBox.vue?vue&type=script&lang=js"
export * from "./ProductStockMovementBox.vue?vue&type=script&lang=js"
import style0 from "./ProductStockMovementBox.vue?vue&type=style&index=0&id=65c6abd7&prod&scoped=true&lang=css"
import style1 from "./ProductStockMovementBox.vue?vue&type=style&index=1&id=65c6abd7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c6abd7",
  null
  
)

export default component.exports